<template>
  <didi-minimal-layout>
    <div class="fullscreen">
      <div
        class="background"
        :style="{
          opacity: activeSlide === 2 ? 1 : 0,
        }"
        style="
          background: black;
          transition: opacity 800ms ease-in-out;
          position: fixed;
          inset: 0;
        "
      />
      <div>
        <ScreensaverLogo
          v-if="activeSlide === 0"
          :screensaverOpacity="screensaverOpacity"
        />
        <ScreensaverNextParty
          v-if="activeSlide === 1"
          :screensaverOpacity="screensaverOpacity"
        />
        <ScreensaverNextFlyer
          v-if="activeSlide === 2"
          :screensaverOpacity="screensaverOpacity"
        />
      </div>
      <div
        class="cycle-indicator"
        :style="{
          width: `${(cycleCount / cyclesUntilReload) * 100}%`,
        }"
      ></div>
      <div
        class="cycle-indicator"
        :style="{
          transition: `width ${
            screensaverOpacity ? slideDuration : 0
          }ms linear`,
          width: `${screensaverOpacity * 100}%`,
        }"
      ></div>
    </div>
  </didi-minimal-layout>
</template>
<script>
import DidiMinimalLayout from "@/layouts/DidiMinimal";
import ScreensaverLogo from "./ScreensaverLogo.vue";
import ScreensaverNextFlyer from "./ScreensaverNextFlyer.vue";
import ScreensaverNextParty from "./ScreensaverNextParty.vue";

const NUM_SLIDES = 3;

export default {
  components: {
    DidiMinimalLayout,
    ScreensaverLogo,
    ScreensaverNextFlyer,
    ScreensaverNextParty,
  },
  data() {
    return {
      activeSlide: -1,
      screensaverOpacity: 0,
      cycleCount: 0,
      cyclesUntilReload: 5,
    };
  },
  mounted() {
    this.nextSlide();
  },
  methods: {
    nextSlide() {
      this.activeSlide = (this.activeSlide + 1) % NUM_SLIDES;
      this.slideDuration = this.activeSlide === 0 ? 60000 : 20000;

      if (this.activeSlide === 0) {
        this.cycleCount += 1;
      }

      // for last minute changes, or surprises
      if (this.cycleCount > this.cyclesUntilReload) {
        window.location.reload();
        return;
      }

      setTimeout(() => {
        this.screensaverOpacity = 1;
      }, 200);
      setTimeout(() => {
        this.screensaverOpacity = 0;
        setTimeout(() => {
          this.nextSlide();
        }, 1500);
      }, this.slideDuration);
    },
  },
};
</script>
<style scoped lang="scss">
div.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  cursor: none;
}

div.cycle-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 8px;
  width: 0;
  background: transparent;
  transition: width 600ms ease-in-out;

  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: rgba(white, 0.4);
  }
}

#layout-screensaver {
  background: transparent;
  position: absolute;
  inset: 0;
}
</style>
